// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dbFile[data-v-a57ddc2e]{\n  padding-top: 2%;\n  padding-left: 4%;\n}\n.e-b[data-v-a57ddc2e]{\n  margin-right: 10px;\n}\n.el-dropdown + .el-dropdown[data-v-a57ddc2e] {\n  margin-left: 15px;\n}\n.el-icon-arrow-down[data-v-a57ddc2e] {\n  font-size: 12px;\n}\n.icon[data-v-a57ddc2e] {\n  width: 1.15em;\n  height: 1.15em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n  margin: 0 8px 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
